export default "__VITE_ASSET__zcX3Ka29__"